{ ExtractionFormField, fieldShape } = require './extraction_form_field'

extractionFormShape = PropTypes.objectOf(
  PropTypes.arrayOf(
    PropTypes.shape(fieldShape)
  )
)

ExtractionForm = createReactClass
  displayName: 'ExtractionForm'

  propTypes:
    asterixedFields: PropTypes.arrayOf(PropTypes.string)
    className: PropTypes.string
    data: PropTypes.object
    form: extractionFormShape.isRequired
    i18n: PropTypes.func.isRequired
    inModal: PropTypes.bool
    renderMode: PropTypes.oneOf(['regular', 'printout'])
    onChange: PropTypes.func.isRequired
    parentValueKey: PropTypes.string
    editable: PropTypes.bool

  getDefaultProps: ->
    asterixedFields: []
    className: null
    inModal: false
    renderMode: 'regular'
    parentValueKey: null
    editable: true

  render: ->
    {
      asterixedFields
      className
      data
      editable
      form
      i18n
      inModal
      onChange
      renderMode
    } = @props

    <div className={classNames 'extraction-form', className, 'in-modal': inModal}>
      {_.map form, (itemGroup, key) ->
        <div key={key} className="extraction-form__group">
        {key not in  ['main', 'thresholds'] and <h2 className="ml-10">{i18n key}</h2>}
        {_.map itemGroup, (item) ->
          { fieldKey } = item
         
          <ExtractionFormField
            i18n={i18n}
            key={fieldKey}
            onChange={onChange}
            renderMode={renderMode}
            data={data}
            readOnly={not editable or item.disabled}
            value={data[fieldKey]}
            withAsterix={fieldKey in asterixedFields}
            {...item}
          />
        }
        </div>
      }
    </div>

module.exports = { ExtractionForm, extractionFormShape }
